import { isInView } from './utils';

const lazyLoad = {
  imgsLazy: document.querySelectorAll('.jsLazy') as NodeListOf<HTMLElement>,
  imgsDoom: document.querySelectorAll(
    '.jsDomLoaded',
  ) as NodeListOf<HTMLElement>,

  init() {
    this.addScroll();
    this.domLoaded();
  },
  addImg(item: HTMLElement) {
    if (item.dataset.img && item.dataset.loaded === 'false') {
      item.style.backgroundImage = `url(${item.dataset.img})`;
      item.dataset.loaded = 'true';
    }
  },
  addScroll() {
    window.addEventListener(
      'scroll',
      () => {
        this.imgsLazy.forEach((item) => {
          if (isInView(item)) {
            this.addImg(item);
          }
        });
      },
      { passive: true },
    );
  },
  domLoaded() {
    window.addEventListener('load', () => {
      this.imgsDoom.forEach((item) => {
        this.addImg(item);
      });
    });
  },
};

export default lazyLoad;
